/**
 * Generates an Excel file from the mapped bus list (BusConnectionMetric shape).
 * data: array of objects with { name, plate, brand, route, city, driver, driverId, phone,
 *   activeTours, daysConnected, daysWithoutConnection, lastConnection, isActive }
 */
export const exportBusActivityExcel = (data) => {
    if (!data || data.length === 0) {
        console.error("No data to export");
        return;
    }

    const headerBg = '#10B981';
    const headerColor = '#ffffff';

    let html = `<table border="1" style="border-collapse: collapse; font-family: Arial, sans-serif; font-size: 12px; width: 100%; text-align: center;">`;

    html += `
        <thead>
            <tr>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Nombre Unidad</th>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Placa</th>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Línea (Super Ruta)</th>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Ruta Asignada</th>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Ciudad</th>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Conductor / Dueño</th>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Cédula</th>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Teléfono</th>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Recorridos Hoy</th>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Días Conectado</th>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Días Desconectado</th>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Última Conexión</th>
                <th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">Estado</th>
            </tr>
        </thead>
        <tbody>
    `;

    data.forEach(bus => {
        html += `
            <tr>
                <td style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">${bus.name}</td>
                <td style="border: 1px solid #D1D5DB; padding: 8px; font-weight: bold; color: #3B82F6;">${bus.plate}</td>
                <td style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">${bus.brand}</td>
                <td style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">${bus.route}</td>
                <td style="border: 1px solid #D1D5DB; padding: 8px;">${bus.city}</td>
                <td style="border: 1px solid #D1D5DB; padding: 8px; text-align: left;">${bus.driver}</td>
                <td style="border: 1px solid #D1D5DB; padding: 8px;">${bus.driverId}</td>
                <td style="border: 1px solid #D1D5DB; padding: 8px;">${bus.phone}</td>
                <td style="border: 1px solid #D1D5DB; padding: 8px; font-weight: bold;">${bus.activeTours}</td>
                <td style="border: 1px solid #D1D5DB; padding: 8px;">${bus.daysConnected}</td>
                <td style="border: 1px solid #D1D5DB; padding: 8px; color: ${bus.daysWithoutConnection > 0 ? '#EF4444' : '#6B7280'};">${bus.daysWithoutConnection}</td>
                <td style="border: 1px solid #D1D5DB; padding: 8px;">${bus.lastConnection}</td>
                <td style="border: 1px solid #D1D5DB; padding: 8px; font-weight: bold; color: ${bus.isActive ? '#10B981' : '#9CA3AF'};">
                    ${bus.isActive ? 'CONECTADO' : 'DESCONECTADO'}
                </td>
            </tr>
        `;
    });

    html += `</tbody></table>`;

    const htmlTemplate = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
        <head>
            <meta charset="utf-8" />
            <style>
                /* Force text format so Excel doesn't auto-convert plates or phones */
                td { mso-number-format:"\\@"; }
                .num { mso-number-format:"General"; }
            </style>
        </head>
        <body>
            <h2 style="font-family: sans-serif; color: #1F2937;">Reporte de Actividad de Unidades</h2>
            <p style="font-family: sans-serif; color: #6B7280;">Generado el: ${new Date().toLocaleString()}</p>
            ${html}
        </body>
        </html>
    `;

    const blob = new Blob([htmlTemplate], { type: 'application/vnd.ms-excel' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    const dateStr = new Date().toISOString().slice(0, 10);
    a.href = url;
    a.download = `Actividad_Buses_${dateStr}.xls`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};
